import { GUARANTEE_IMG, BASE } from "@/lib/site-data";
import { useHairLossSwap } from "@/lib/hair-loss-copy";
export function Guarantee({
  backgroundColor = "#f5f5f5",
  variant = "default",
  imageClassName = "",
  wpCopy,
}: {
  backgroundColor?: string;
  variant?: "default" | "results";
  imageClassName?: string;
  /** WordPress wording for the default variant: two h3 lines and one h2 paragraph (html). */
  wpCopy?: { h3a: string; h3b: string; bodyHtml: string; bodyTag?: "p" | "h2" };
}) {
  const swap = useHairLossSwap();
  if (variant === "results") {
    return (
      <section
        className="relative border-y-4 border-primary bg-background py-12 md:py-16"
      >
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 md:grid-cols-[1fr_auto] md:gap-12 lg:px-8">
          <div className="text-center md:text-left">
            <h3 className="font-extrabold leading-tight text-foreground text-[34px] sm:text-5xl md:text-[56px]">
              You'll Love the New You
            </h3>
            <p
              className="mt-2 leading-tight text-[40px] sm:text-6xl md:text-[64px]"
              style={{ color: "#c9a04a", fontFamily: "Poppins, sans-serif", fontWeight: 700 }}
            >
              Guaranteed.
            </p>
            <p className="mt-5 text-base leading-relaxed text-foreground">
              {swap("Your satisfaction is our #1 priority — and we stand behind our quality and expertise of our hair transplant surgeons 100%. If for any reason you're not happy with the results of your RESTORE F.U.E. hair restoration procedure, we'll perform an additional procedure at no cost to you.")}
            </p>
          </div>
          <a href={`${BASE}/restore-pledge/`} className="mx-auto md:mx-0">
            <img loading="lazy" decoding="async"
              src={GUARANTEE_IMG}
              alt="RESTORE Hair Satisfaction Guarantee"
              width={260}
              height={233}
              className="mx-auto"
              style={{ width: 260, height: 233 }}
            />
          </a>
        </div>
      </section>
    );
  }
  if (wpCopy) {
    return (
      <section className="relative py-16 md:py-24" style={{ backgroundColor }}>
        <div className="relative mx-auto max-w-6xl px-4 text-center lg:px-8">
          <a href={`${BASE}/restore-pledge/`} className={`inline-block ${imageClassName}`.trim()}>
            <img loading="lazy" decoding="async"
              src={GUARANTEE_IMG}
              alt="RESTORE Hair Satisfaction Guarantee"
              width={220}
              height={197}
              className="mx-auto"
              style={{ width: 220, height: 197 }}
            />
          </a>
          <div className="mx-auto mt-3 max-w-6xl">
            <h3 className="font-extrabold leading-tight text-foreground text-[28px] sm:text-4xl md:text-[48px]">
              {wpCopy.h3a}
            </h3>
            <h3 className="mt-3 font-semibold text-foreground leading-[1.1] text-[28px] sm:text-4xl md:text-[48px]">
              {wpCopy.h3b}
            </h3>
            {wpCopy.bodyTag === "h2" ? (
              <h2
                className="mt-4 text-base font-normal leading-relaxed text-foreground [&_a]:font-bold [&_a]:underline"
                dangerouslySetInnerHTML={{ __html: wpCopy.bodyHtml }}
              />
            ) : (
              <p
                className="mt-4 text-base leading-relaxed text-foreground [&_a]:font-bold [&_a]:underline"
                dangerouslySetInnerHTML={{ __html: wpCopy.bodyHtml }}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="relative py-16 md:py-24" style={{ backgroundColor }}>
      <div className="relative mx-auto max-w-6xl px-4 text-center lg:px-8">
        <a href={`${BASE}/restore-pledge/`} className={`inline-block ${imageClassName}`.trim()}>
          <img loading="lazy" decoding="async"
            src={GUARANTEE_IMG}
            alt="RESTORE Hair Satisfaction Guarantee"
            width={220}
            height={197}
            className="mx-auto"
            style={{ width: 220, height: 197 }}
          />
        </a>
        <div className="mx-auto mt-3 max-w-6xl">
          <h3 className="font-extrabold leading-tight text-foreground text-[28px] sm:text-4xl md:text-[48px]">
            Your Satisfaction is Our <span className="text-foreground">#1 Priority</span>
          </h3>
          <p className="mt-3 font-semibold text-foreground leading-[1.1] text-[28px] sm:text-4xl md:text-[48px]">
            More Than 20,000+ Successful Procedures
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground">
            We stand by our quality and expertise 100%. If for any reason you're not happy with the
            results of your RESTORE procedure, we'll perform an additional procedure at no cost to
            you.
            <br />
            For complete details,{" "}
            <a
              href={`${BASE}/restore-pledge/`}
              className="font-bold text-foreground underline hover:no-underline"
            >
              read the RESTORE Pledge
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}